import { ArrowsClockwise, Trash } from '@phosphor-icons/react'
import LoadingButton from 'Organisms/LoadingButton'
import { countDecimalsAndAdd0 } from 'Utils/helperFunctions'
import moment from 'moment'
// Shared inline-rate widget used by the Team section for per-member rates.
import RateCell from '../../Team/Components/RateCell'

const TableTasks = ({ tasks, onDelete, onSaveBillableRate, billing, budget }) => {
  const getRest = ({ spent, budget }) => {
    return countDecimalsAndAdd0({ number: budget - spent })
  }
  const getPercent = ({ spent, budget }) => {
    if (spent === 0) return 0

    if (budget === 0) return 100

    return countDecimalsAndAdd0({ number: (spent * 100) / (budget || 0) })
  }
  return (
    <div className="table-responsive">
      <table className="table align-middle">
        <thead>
          <tr>
            <th scope="col" className='px-4'>Name</th>
            { (budget?.type !== 'Fee per task type' && budget?.type !== 'Hours per task type') && (
              <th scope="col">Hours</th>
            )}
            <th scope="col" className="width-150 text-no-wrap">
              Last modification
            </th>
            { billing?.method === 'Charge per task type' && (
              <th scope="col" className="width-150 text-no-wrap">
                Billable Rate
              </th>
            )}
            <th />
          </tr>
        </thead>
        <tbody>
          {tasks.map((task) => (
            <tr key={task.id} >
              <td className="text-no-wrap px-4">
                <span className="row justify-content-between mb-2">
                  <span className="col-auto">{task?.name || task?.task?.name || ''}</span>
                  { (budget?.type === 'Fee per task type' || budget?.type === 'Hours per task type') && (
                    <span className="col-auto">{countDecimalsAndAdd0({ number: task?.spent || 0 })}h</span>
                  )}
                </span>
                { (budget?.type === 'Fee per task type' || budget?.type === 'Hours per task type') && (
                  <>
                    <span className="row justify-content-between">
                      <span className="col-auto">
                        <p className='small mb-1'>Budget: {task.budget}h <span data-bs-toggle="tooltip" data-bs-title="Default tooltip" >{ budget?.method === 'Recurrent' && <>&#8226; <ArrowsClockwise style={{ position: 'relative', top: '-2px' }} size={16} /> <span>Resets each {budget?.frequency}</span></>}</span></p>
                      </span>
                      <span className="col-auto">
                        <p className='small mb-1'>Remaining: {getRest({ spent: task?.spent || 0, budget: task?.budget || 0 })}h</p>
                      </span>
                    </span>
                    <span className='row mb-2'>
                      <div className='col-12'>
                        <div
                          style={{ width: '100%', height: '4px' }}
                          className="progress"
                          role="progressbar"
                          aria-label="Basic example"
                          aria-valuenow="0"
                          aria-valuemin="0"
                          aria-valuemax="100">
                            <div
                              className="progress-bar"
                              style={{
                                width: `${getPercent({ spent: Math.min(task?.spent || 0, task?.budget || 0), budget: task?.budget || 0 })}%`,
                                backgroundColor: '#31f7f2'
                              }}></div>

                            {task?.spent > task?.budget && (
                                <div
                                  className="progress-bar"
                                  style={{
                                    width: `${getPercent({ spent: task?.spent - task?.budget, budget: task?.budget || 0 })}%`,
                                    backgroundColor: '#BC5776ff'
                                  }}
                                ></div>
                            )}
                        </div>
                      </div>
                    </span>
                  </>
                )}
              </td>
              { (budget?.type !== 'Fee per task type' && budget?.type !== 'Hours per task type') && (
                <td><span className="col-auto">{countDecimalsAndAdd0({ number: task?.spent || 0 })}h</span></td>
              )}
              <td className=" text-no-wrap">
                {task?.updated_at ? moment(task.updated_at).format('DD/MM/YYYY') : moment().format('DD/MM/YYYY')}
              </td>
              { billing?.method === 'Charge per task type' && (
                <td className="text-no-wrap">
                  <RateCell
                    id={`taskBillableRate-${task?.task?.id || task?.id || ''}`}
                    ariaLabel={`Billable rate for ${task?.name || task?.task?.name || 'task'}`}
                    savedRate={task?.billable ?? task?.billable_rate ?? null}
                    onSave={(value) =>
                      onSaveBillableRate({ idTask: task?.task?.id || task?.id || '', value })
                    }
                  />
                </td>
              )}
              <td className="text-end">
                <LoadingButton
                  type="button"
                  onClick={() => onDelete({ idTask: task?.task?.id || task?.id || '' })}
                  className="btn btn-secondary">
                  <Trash size={18} color="#262422" weight="bold" />
                </LoadingButton>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default TableTasks
